//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum AggregationStatType {
  Comments = 'comments',
  EngagementRate = 'engagementRate',
  Followers = 'followers',
  Likes = 'likes',
  Reach = 'reach',
  Impressions = 'impressions',
  Views = 'views',
  // TODO: change this back to 'storyCompletionRate' once DEV-52286 is merged
  StoryCompletionRate = 'completion',
  EngagementRateWithReach = 'engagementRateWithReach',
  Repins = 'repins',
}

type PostStatAggregationType =
  | AggregationStatType.Comments
  | AggregationStatType.Followers
  | AggregationStatType.Impressions
  | AggregationStatType.Views
  | AggregationStatType.Likes
  | AggregationStatType.Reach;
export type PostsStatAggregationArray =
  IAggregationStat<PostStatAggregationType>[];

export type PostStatHistogramAggregationType =
  | AggregationStatType.Comments
  | AggregationStatType.Followers
  | AggregationStatType.Likes
  | AggregationStatType.Reach;
export type PostsStatHistogramArray =
  IAggregationResultHistogramBucket<PostStatHistogramAggregationType>[];

export interface IAggregationStat<T extends AggregationStatType> {
  name: T;
  value: IAggregationStatValue;
}

interface IAggregationStatValue {
  avg: number;
  max: number;
  min: number;
  sum: number;
}

export interface IAggregationResultHistogramBucket<
  T extends AggregationStatType,
> {
  date: Date;
  count: number;
  stats: IAggregationStat<T>[];
}
